import React from "react";
import CesiumViewer from "./burnair/CesiumViewer";

function App() {

    return (        
        <CesiumViewer/>
    );
}

export default App;
